module.exports = __webpack_public_path__ + "img/list.151991a3.png";